module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.filterUsers
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "User Email",
      "min-width": 25,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "Role",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zone_name",
      "label": "Active Zone",
      "sortable": "",
      "min-width": 25
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "min-width": 25
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userZonesClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Zones")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.userDeleteClick(scope.$index, scope.row)
            }
          }
        }, [_vm._v("Delete")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userDeleteDialog.title,
      "visible": _vm.userDeleteDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userDeleteDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userDeleteDialog.loading),
      expression: "userDeleteDialog.loading"
    }],
    attrs: {
      "model": _vm.userDeleteDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userDeleteDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userDeleteDialog.form, "email", $$v)
      },
      expression: "userDeleteDialog.form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userDeleteDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.userDeleteDialogClick()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.userZonesDialog.title,
      "visible": _vm.userZonesDialog.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.userZonesDialog, "visible", $event)
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userZonesDialog.loading),
      expression: "userZonesDialog.loading"
    }],
    attrs: {
      "model": _vm.userZonesDialog.form
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "User Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.userZonesDialog.form.email),
      callback: function($$v) {
        _vm.$set(_vm.userZonesDialog.form, "email", $$v)
      },
      expression: "userZonesDialog.form.email"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.userZonesDialog.form.zones), function(zone) {
    return _c('el-tag', {
      staticStyle: {
        "margin-right": "10px",
        "margin-bottom": "5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleRemoveAccessZone(zone.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(zone.name) + "\n            ")])
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.userZonesDialog.visible = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11b65c59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Users.vue
// module id = 1384
// module chunks = 1